import { c as _c } from "react/compiler-runtime";
export default function MediumIcon() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_380_2290)"><path d="M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z" fill="black" /><path d="M49.3799 45C49.3799 55.7237 40.7459 64.417 30.0952 64.417C19.4446 64.417 10.8105 55.7237 10.8105 45C10.8105 34.2763 19.4446 25.583 30.0953 25.583C40.7459 25.583 49.3799 34.2763 49.3799 45Z" fill="white" /><path d="M70.5358 44.9999C70.5358 55.0945 66.2188 63.2776 60.8935 63.2776C55.5682 63.2776 51.2512 55.0945 51.2512 44.9999C51.2512 34.9053 55.5682 26.7222 60.8935 26.7222C66.2188 26.7222 70.5358 34.9053 70.5358 44.9999Z" fill="white" /><path d="M79.1895 44.9999C79.1895 54.0442 77.6711 61.376 75.7982 61.376C73.9252 61.376 72.407 54.0442 72.407 44.9999C72.407 35.9556 73.925 28.6238 75.7982 28.6238C77.6711 28.6238 79.1895 35.9556 79.1895 44.9999Z" fill="white" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-w-full tw-h-full tw-rounded-full tw-ring-1 tw-ring-white/20 tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}<defs><clipPath id="clip0_380_2290"><rect width="90" height="90" fill="white" /></clipPath></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}